
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"WorkOrderPartDetails"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"WorkOrderPart"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"WorkOrderRecIdRef"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"LineNo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Quantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ItemRecIdRef"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"LineNote"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Inventoried"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Description"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"PriceEach"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Extension"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"PostFlag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"PostDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"BillFlag"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"BillDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ItemCategoryRecIdRef"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Taxable"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"MarkUpCost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Cost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Active"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"RecId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"CompanyId"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"InvDim1RecIdRef"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"InvDim2RecIdRef"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"InvDim3RecIdRef"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":419}};
    doc.loc.source = {"body":"fragment WorkOrderPartDetails on WorkOrderPart {\n  WorkOrderRecIdRef\n  LineNo\n  Quantity\n  ItemRecIdRef\n  LineNote\n  Inventoried\n  Description\n  PriceEach\n  Extension\n  PostFlag\n  PostDate\n  BillFlag\n  BillDate\n  ItemCategoryRecIdRef\n  Taxable\n  MarkUpCost\n  Cost\n  Active\n  RecId\n  CompanyId\n  InvDim1RecIdRef\n  InvDim2RecIdRef\n  InvDim3RecIdRef\n  # CreatedDateTime\n  # ModifiedDateTime\n  # CreatedBy\n  # ModifiedBy\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["WorkOrderPartDetails"] = oneQuery(doc, "WorkOrderPartDetails");
        
